import React from 'react';
import { ErrorMessage } from 'formik';
import classnames from 'classnames';
import LabelR from '../../Simple/LabelR';
import TagInput from '../TagInput';

const TagInputFormik = (props) => {
  const {
    field: { name, value, onBlur },
    form: { touched, errors, setFieldValue },
    label,
    disabled = false,
    required,
    requiredFields = [name],
    onChange,
  } = props;

  const valueChange = (value) => {
    setFieldValue(name, value);
    onChange && onChange(value);
  };

  return (
    <div className="form-group" id={`${name}-container-input`}>
      {label &&
        (required ? (
          <LabelR requiredFields={requiredFields} isEditable={!disabled} htmlFor={name}>
            {label}
          </LabelR>
        ) : (
          <label htmlFor={name}>{label}</label>
        ))}
      <TagInput
        {...props}
        className={classnames({
          'is-invalid invalid-field': errors[name] && touched[name],
          'static-label': !!disabled,
        })}
        onChange={valueChange}
        onBlur={onBlur}
        value={value || []}
        name={name}
      />
      {touched[name] && errors[name] && <ErrorMessage name={name} component="div" className="invalid-feedback" />}
    </div>
  );
};

export default TagInputFormik;
